/**
 * @module constants
 */

/**
 * @constant
 * Event name for logging telemetry when user clicks on invoke add-in action
 */

export const INVOKE_ADDIN_COMMAND_CLICKED = 'MessageCardInvokeAddinCommandClicked';

/**
 * @constant
 * Event name for logging telemetry when user clicks on pin add-in action
 */

export const PIN_ADDIN_COMMAND_CLICKED = 'MessageCardPinAddinCommandClicked';

/**
 * @constant
 * Event name for logging telemetry user clicks on displayAppointmentForm action
 */

export const DISPLAY_APPOINTMENT_FORM_CLICKED = 'DisplayAppointmentFormClicked';

/**
 * @constant
 * Event name for logging telemetry user clicks on displayMessageForm action
 */

export const DISPLAY_MESSAGE_FORM_CLICKED = 'DisplayMessageFormClicked';

/**
 * @constant
 * A key to access action context from the Action object
 */

export const ACTION_CONTEXT = 'actionContext';

/**
 * @constant
 * An amount of time to wait for the card to be ready before showing the message body
 */

export const CARD_LOAD_TIMEOUT = 4000;
